import JobList from '../../views/Job/JobList';

export default [
    {
        path: '/processos',
        name: 'job.list',
        component: JobList,
        meta: {
            pageTitle: 'Processos',
            breadcrumb: [
                { label: 'Processos' },
            ],
        },
    },
];
